import React from "react";
import { FaPlus } from "react-icons/fa";

function AccountsHeader({ onAddClick }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="min-w-0">
        <h1 className="text-lg font-bold leading-tight text-[#35314d] sm:text-xl">
          Accounts
        </h1>
        <p className="mt-0.5 text-xs leading-snug text-gray-500">
          Manage employee accounts, roles, and access permissions
        </p>
      </div>
      <button
        type="button"
        onClick={onAddClick}
        className="inline-flex shrink-0 items-center gap-2 rounded-lg bg-[#007BFF] px-5 py-2.5 text-sm font-bold text-white shadow-md transition hover:bg-[#0069D9] hover:shadow-lg"
        style={{ boxShadow: "0 2px 8px rgba(0, 123, 255, 0.28)" }}
      >
        <FaPlus size={13} />
        Add Account
      </button>
    </div>
  );
}

export default AccountsHeader;
